import React, { Fragment } from "react";
import { Col } from "reactstrap";
import { LIGHT_THEME_LIST } from "../../../../Data/UiKit/Alert";
import { Alerts, P } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";

export const LightThemeLeftSection = () => {
  return (
    <Col xl="6">
      <P className="mb-0">Primary Light Alert</P>
      <Alerts color="light-primary">
        <P className="txt-primary">This is a
          <a className="alert-link txt-primary" href={Href}>primary alert</a>
          with an example link.Check it out.
        </P>
      </Alerts>
      {LIGHT_THEME_LIST.map((title, index) => (
        <Fragment key={index}>
          <P className="mb-0 text-capitalize">{title} Light Alert</P>
          <Alerts className={`alert-light-${title}`}>
            <P className={`txt-${title}`}>{`This is a `}
              <a className={`alert-link txt-${title}`} href={Href}>
                {title} alert
              </a> with an example link. Check it out.
            </P>
          </Alerts>
        </Fragment>
      ))}
    </Col>
  );
};
